// Auto-generated from network-overview.html. Verbatim redesign import. Do NOT edit.
export const MARKUP = `
<header class="page-header">
<canvas aria-hidden="true" class="page-header-canvas" id="netOverviewHeroCanvas"></canvas>
<div class="page-header-veil"></div>
<div class="wrap">
<h1 class="reveal">The <span class="accent">Utility</span> Network.</h1>
<p class="lede reveal">Everything you need to issue, manage, and distribute compliant tokenized assets.</p>
<div class="cta-row reveal">
<a class="btn btn-primary" href="/contact">Talk to an expert</a>
</div>
</div>
</header>

<section class="section section-day">
<div class="wrap">
<div class="section-head reveal">
<h2 class="head" style="max-width:32ch">Regulated assets onchain<br/>carry rules that must <span class="accent">travel</span>.</h2>
<p class="lede">When a regulated asset is tokenized, its investor eligibility and transfer restrictions have to hold on every chain it reaches, and issuers need one authoritative record of ownership behind them all. Maintaining that single compliance state across many blockchains is the hard part, and the part T-REX Network is built to solve.</p>
</div>
<div class="pv-compare reveal" id="pvCompare">
<div class="cmp is-today">
<div class="cmp-label">Without shared infrastructure</div>
<h3>One asset, conflicting copies.</h3>
<div class="cmp-diagram">
<svg height="100%" style="fill-rule:evenodd;clip-rule:evenodd;" version="1.1" viewbox="0 0 360 150" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:serif="http://www.serif.com/" xmlns:xlink="http://www.w3.org/1999/xlink">
<g opacity="0.5">
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M88,55L113,55" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.3px;stroke-dasharray:3,5;"></path>
</g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M137,55L162,55" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.3px;stroke-dasharray:3,5;"></path>
</g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M198,55L223,55" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.3px;stroke-dasharray:3,5;"></path>
</g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M247,55L272,55" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.3px;stroke-dasharray:3,5;"></path>
</g>
</g>
<g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M118,49L132,61" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.6px;stroke-linecap:round;"></path>
</g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M132,49L118,61" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.6px;stroke-linecap:round;"></path>
</g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M228,49L242,61" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.6px;stroke-linecap:round;"></path>
</g>
<g transform="matrix(1,0,0,1,0,-6)">
<path d="M242,49L228,61" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.6px;stroke-linecap:round;"></path>
</g>
</g>
<g transform="matrix(1,0,0,1,70,48)">
<g id="frag-cube">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g transform="matrix(1,0,0,1,180,48)">
<g id="frag-cube1" serif:id="frag-cube">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g transform="matrix(1,0,0,1,290,48)">
<g id="frag-cube2" serif:id="frag-cube">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g>
<g transform="matrix(1,0,0,1,70,92)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain A</text>
</g>
<g transform="matrix(1,0,0,1,180,92)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain B</text>
</g>
<g transform="matrix(1,0,0,1,290,92)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain C</text>
</g>
</g>
<g transform="matrix(1,0,0,1,180,126)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10.5px;fill:rgb(79,69,56);" x="-81.9px" y="0px">Three records. None agree.</text>
</g>
</svg>
</div>
<p class="cmp-foot">Each chain holds its own local copy. Eligibility checks disagree, records drift, and reconciliation falls to people.</p>
</div>
<div class="cmp-vs">vs</div>
<div class="cmp is-trex">
<div class="cmp-label">On T-REX Network</div>
<h3>One asset, one golden record.</h3>
<div class="cmp-diagram">
<svg height="100%" style="fill-rule:evenodd;clip-rule:evenodd;" version="1.1" viewbox="0 0 360 200" width="100%" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:serif="http://www.serif.com/" xmlns:xlink="http://www.w3.org/1999/xlink">
<g opacity="0.85">
<g>
<path d="M180,100L180,44" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path>
<path d="M180,100L180,156" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path>
</g>
<g transform="matrix(1,0,0,1,-1,0)">
<g transform="matrix(1.03,0,0,1.03,-5.4,-3)">
<path d="M180,100L80,100" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path>
</g>
<g transform="matrix(1.05,0,0,1.05,-9,-5)">
<path d="M180,100L280,100" style="fill:none;fill-rule:nonzero;stroke:rgb(255,122,51);stroke-width:1.4px;"></path>
</g>
</g>
</g>
<g>
<g transform="matrix(1,0,0,1,0,5)">
<circle cx="180" cy="68" r="2.6" style="fill:rgb(255,122,51);"></circle>
</g>
<g transform="matrix(1,0,0,1,0,-5)">
<circle cx="180" cy="132" r="2.6" style="fill:rgb(255,122,51);"></circle>
</g>
<circle cx="126" cy="100" r="2.6" style="fill:rgb(255,122,51);"></circle>
<circle cx="234" cy="100" r="2.6" style="fill:rgb(255,122,51);"></circle>
</g>
<circle cx="180" cy="100" r="34" style="fill:none;stroke:rgb(255,122,51);stroke-opacity:0.5;stroke-width:1.3px;"></circle>
<circle cx="180" cy="100" r="15" style="fill:url(#_Radial1);"></circle>
<g transform="matrix(1,0,0,1,180,40)">
<g id="uni-cube">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g transform="matrix(1,0,0,1,180,160)">
<g id="uni-cube1" serif:id="uni-cube">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g transform="matrix(1,0,0,1,64,100)">
<g id="uni-cube2" serif:id="uni-cube" transform="matrix(1,0,0,1,0,-1)">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g transform="matrix(1,0,0,1,296,100)">
<g id="uni-cube3" serif:id="uni-cube" transform="matrix(1,0,0,1,0,-1)">
<path d="M0,-14L14,-7L0,0L-14,-7L0,-14Z" style="fill:rgb(244,229,194);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M-14,-7L0,0L0,16L-14,9L-14,-7Z" style="fill:rgb(232,217,184);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
<path d="M14,-7L0,0L0,16L14,9L14,-7Z" style="fill:rgb(216,199,154);fill-rule:nonzero;stroke:rgb(168,139,74);stroke-width:1.2px;stroke-linejoin:round;"></path>
</g>
</g>
<g>
<g transform="matrix(1,0,0,1,179.750977,22)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain A</text>
</g>
<g transform="matrix(1,0,0,1,64,126)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain B</text>
</g>
<g transform="matrix(1,0,0,1,296,126)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain C</text>
</g>
<g transform="matrix(1,0,0,1,179.970703,190)">
<text style="font-family:'JetBrainsMono-Regular', 'JetBrains Mono', monospace;font-size:10px;fill:rgb(21,16,42);" x="-21px" y="0px">Chain D</text>
</g>
</g>
<defs>
<radialgradient cx="0" cy="0" gradienttransform="matrix(21,0,0,21,176.4,95.2)" gradientunits="userSpaceOnUse" id="_Radial1" r="1"><stop offset="0" style="stop-color:rgb(255,217,160);stop-opacity:1"></stop><stop offset="0.42" style="stop-color:rgb(255,122,51);stop-opacity:1"></stop><stop offset="1" style="stop-color:rgb(194,82,28);stop-opacity:1"></stop></radialgradient>
</defs>
</svg>
</div>
<p class="cmp-foot">Every chain references one canonical record on the Ledger. Compliance is established once and stays in sync everywhere.</p>
</div>
</div>
</div>
</section>

<section class="section section-day">
<div class="wrap">
<div class="section-head reveal">
<h2 class="head" style="max-width:34ch"><span class="accent">Tokenize</span> on the Protocol.<br/><span class="accent">Manage</span> compliance on the Ledger.<br/><span class="accent">Distribute</span> through the AppStore.</h2>
</div>
<div class="wf-stage reveal" id="workflowStage">
<canvas aria-hidden="true" id="workflowCanvas"></canvas>
<div class="wf-grid reveal-cards" id="wfGrid">
<div class="wcard active" data-state="0">
<div class="wcard-body">
<span class="verb"><span class="tick"></span>Tokenize</span>
<h3>Protocol</h3>
<p class="cap">Compliance, written into the asset.</p>
<div class="wcard-detail">
<p>The open-source ERC-3643 standard embeds investor eligibility and transfer rules directly into the token, unlike permissionless standards such as ERC-20, ERC-721, and ERC-1155. The specification is curated by the ERC3643 Association, a non-profit organisation, and adopted by 140+ institutions across the wider community. $32B+ tokenized, cited by the SEC Chairman twice, and used by DTCC, Deloitte, Apex, ABN AMRO, Chainlink, Fireblocks, and more.</p>
<a class="wcta" href="/network/erc-3643">Read the standard <span class="chev">→</span></a>
</div>
<span class="n">01</span>
</div>
</div>
<div class="wcard" data-state="1">
<div class="wcard-body">
<span class="verb"><span class="tick"></span>Manage</span>
<h3>Ledger</h3>
<p class="cap">One record, synced across every chain.</p>
<div class="wcard-detail">
<p>Every asset is anchored to a single canonical record on the Ledger, and that record syncs across every chain it touches. Each transfer queries the Ledger before it clears, so compliance is established once and travels with the asset everywhere. The infrastructure behind Apex Group's $100B commitment.</p>
<a class="wcta" href="/network/ledger">See the Ledger <span class="chev">→</span></a>
</div>
<span class="n">02</span>
</div>
</div>
<div class="wcard" data-state="2">
<div class="wcard-body">
<span class="verb"><span class="tick"></span>Distribute</span>
<h3>AppStore</h3>
<p class="cap">Where the apps operate together.</p>
<div class="wcard-detail">
<p>A curated marketplace of vetted issuance, custody, distribution, and analytics apps, pre-integrated and ready to build with. Every app is reviewed across legal, technical, business, operational, and security dimensions before listing.</p>
<a class="wcta" href="/solutions/app-store">Browse the AppStore <span class="chev">→</span></a>
</div>
<span class="n">03</span>
</div>
</div>
</div>
</div>
<p class="lede reveal">The three pillars are one shared infrastructure layer for tokenized securities. Together they cover the full path, from compliant issuance, to distribution across chains, to providing active utility in onchain markets. Issuers move from issuance to working markets without rebuilding and reconciling a separate system at each step.</p>
</div>
</section>

<section class="section section-night center">
<div class="wrap">
<div class="reveal">
<h2 class="head">Pick your <span class="accent">starting point</span>.</h2>
<p class="lede">Two doors into the same Network. Issue an asset or explore the ecosystem.</p>
</div>
<div class="doors reveal">
<a class="door" href="/contact">Tokenize an Asset <svg fill="none" height="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewbox="0 0 24 24" width="14"><path d="M5 12h14M13 6l6 6-6 6"></path></svg></a>
<a class="door" href="/ecosystem">Explore the ecosystem <svg fill="none" height="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" viewbox="0 0 24 24" width="14"><path d="M5 12h14M13 6l6 6-6 6"></path></svg></a>
</div>
</div>
</section>
`;
